import Swal from "sweetalert2";
import dayjs from "dayjs";

import { DocumentsUploadsResponse, DocumentUpload } from "../../models/Referral";
import { getValue } from "../../utils";
import colors from "../../styles/colors/colors";
import { MessageType, ResponseMessages } from "../../constants/ResponseMessage";
import { PdfIconeStyle } from "../../routes/PriorAuthWorkFlow/styles/style";
import { DateFormats } from "../../constants/Date";
import fontWeight from "../../styles/mui/fontWeight";

export const getDocumentStatusList = (
  documentUploads: DocumentsUploadsResponse[] | null
) => {
  const docListHtml = `
    <div style="text-align:left; padding:10px; background-color:#f7f7f7;">
       <div style="margin-bottom:10px; font-size:13px"><b>Uploaded Documents:</b></div>
        <div style="max-height:120px; overflow-y:auto; margin:5px 0; padding-right:2px;">
            <ul style="padding-left:12px; margin:0; list-style-type: none;">
                ${
                  documentUploads &&
                  documentUploads
                    .map((doc: DocumentsUploadsResponse, index: number) => {
                      const color = (() => {
                        if (doc.status === "Succeeded") return "green";
                        if (doc.status === "Failed") return "red";
                        return "inherit";
                      })();
                      return `<li style="margin-bottom:10px; font-size:13px; display: flex; align-items: flex-start; border-bottom: 1px solid #ccc; padding-bottom: 5px;">
  <span style="width: 30px; font-weight: bold;">${index + 1})</span>
  <span style="flex-grow: 1;">
    ${doc.documentName} - <span style="color: ${color};">${doc.status}</span>
  </span>
</li>`;
                    })
                    .join("")
                }
            </ul>
        </div>
    </div>
`;
  return docListHtml;
};
export const getNoDocumentUploadedStatus = () => {
  const docHtml = `
    <div style="text-align:left; padding:10px; background-color:#f7f7f7;">
       <div style="margin-bottom:10px; font-size:13px"><b>All document upload failed.</b></div>
    </div>
`;
  return docHtml;
};

export const downloadDEDocument = (documentList: any, onDocumentClick: (id: number) => void) => {
  const downloadBtnId = `download-btn-${documentList[0]?.blobId}`;
  const blobId = Number(documentList[0]?.blobId);
  if (Number.isFinite(blobId)) {
    (window as any).__deDownloadDoc = () => {
      onDocumentClick(blobId);
    };
  }
  const docHtml = `
    <div style="display: flex; align-items: flex-start; justify-content: center; gap: 4px; flex-wrap: nowrap;">
      <div style="display: flex; align-items: center; justify-content: center; ${PdfIconeStyle}">
        <span style="font-size: 1.5rem; margin-top: 0.1rem; color: ${colors.primary.main};">
         <i class="fa fa-file-pdf-o"></i>
        </span>
      </div>
      <div style="min-width: 0; margin-left: 0.625rem; margin-right: 0.625rem;">
        <div style="display: flex; flex-direction: column; align-items: flex-start;">
          <div
            style="color: ${colors.black[4]}; font-weight: ${fontWeight[3]}; font-size: 1rem; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis; white-space: normal; word-break: break-word; line-height: 1.3; max-height: 2.6em; text-align: left;"
            title="${documentList[0]?.originalDocumentName}"
          >
            ${documentList[0]?.originalDocumentName}
          </div>
          <div style="font-weight: ${fontWeight[3]};color: ${colors.fonts[4]}; font-size: 1rem; text-align: left;">
            ${dayjs(documentList[0]?.dateTimeReceived).format(DateFormats.MM_DD_YYYY_comma_hh_mm_ss_a)}
          </div>
        </div>
      </div>
      <div style="flex: 0 0 auto; margin-left: 0.8rem; margin-top: 0.1125rem;" title="Download">
        <button type="button" style="font-size: 2.2rem;  margin-left: 1rem; color: ${colors.primary.main}; cursor: pointer; background: transparent; border: none; padding: 0;" id="${downloadBtnId}" aria-label="Download" onclick="window.__deDownloadDoc && window.__deDownloadDoc()">
          <i class="fa fa-download"></i>
        </button>
      </div>
    </div>
  `;
  return docHtml;
};

 const baseConfig = (
    setShowAlert: any,
    resetExistingApiResponse: any,
    reset: any,
    onClose?: (value: number) => void,
    titleColor?: string
  ) => {
    const baseConfig = {
        icon: "info",
        confirmButtonText: "Ok",
        confirmButtonColor: colors.portalColor[13],
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
          confirmButton: "swal-confirm-btn",
          popup: "swal-popup-custom-zindex",
        },
        willClose: () => {
          setShowAlert(null);
          setTimeout(() => {
            if (typeof resetExistingApiResponse === 'function') {
              resetExistingApiResponse();
            }
            if (typeof reset === 'function') {
              reset();
            }
          }, 100);
        },
        didOpen: (popup: HTMLElement) => {
          popup.style.zIndex = "10";
          const title = popup.querySelector(".swal2-title") as HTMLElement | null;
          if (titleColor && title) {
            title.style.color = titleColor;
          }
          const closeBtn = popup.querySelector(".swal2-close") as HTMLButtonElement | null;
          if (closeBtn && typeof onClose === "function") {
            closeBtn.onclick = () => onClose(0);
          }
        },
    };
    return baseConfig;
  }
export const callFailedSwalVisible = (documentUploadState: DocumentUpload, showAlert: any, setShowAlert: any, resetExistingApiResponse: any, reset: any) => {
    if (Swal.isVisible()) {
      if (Swal.isVisible()) {
        const html = `Some or all documents failed to upload.<br /><br /><b>${showAlert?.message1} #: ${showAlert?.message2}</b><br />Please submit a Freshdesk ticket with your Confirmation #  and all documents related to this request for assistance.<br /><br />Tip: Do not resubmit authorization request, unless advised.<span id="swal-loader-msg">`;
        const configUpdate = {
          ...baseConfig(setShowAlert, resetExistingApiResponse, reset),
          html:
            showAlert?.message1 ===
            ResponseMessages(MessageType.REFERRAL_NOT_CREATED)
              ? `${showAlert?.message1}`
              : html,
          title:
            showAlert?.message1 ===
            ResponseMessages(MessageType.REFERRAL_NOT_CREATED)
              ? "Error"
              : "Success",
          icon:
            showAlert?.message1 ===
            ResponseMessages(MessageType.REFERRAL_NOT_CREATED)
              ? "error"
              : "warning",
          type:
            showAlert?.message1 ===
            ResponseMessages(MessageType.REFERRAL_NOT_CREATED)
              ? "error"
              : "success",
        } as import("sweetalert2").SweetAlertOptions;
        Swal.fire({
          ...configUpdate,
          html:
            (html ?? "") +
            getDocumentStatusList(
              getValue(documentUploadState, "documentUploads")
            ),
        });
      }
    }
  };
export const callSuccessSwalVisible = (documentUploadState: DocumentUpload, showAlert: any, setShowAlert: any, resetExistingApiResponse: any, reset: any) => {
     if (Swal.isVisible()) {
       const html = `${ResponseMessages(
         MessageType.DOCUMENT_UPLOADED_SUCCESSFULLY
       )}<br /><br /><b>${showAlert?.message1} #: ${
         showAlert?.message2
       }</b><br /><br /><div style="text-align:center; padding-bottom:10px;">You may now close this window.</div>`;
       const configUpdate = {
         ...baseConfig(setShowAlert, resetExistingApiResponse, reset),
         html:
           (html ?? "") +
           getDocumentStatusList(
             getValue(documentUploadState, "documentUploads")
           ),
         icon: "success",
         type: "success",
         title: "Success",
       } as import("sweetalert2").SweetAlertOptions;

       Swal.fire(configUpdate);
     }
};
export const callDocumentErrorSwal = (_documentUploadState: DocumentUpload, showAlert: any, setShowAlert: any, resetExistingApiResponse: any, reset: any) => {
    if (Swal.isVisible()) {
      if (Swal.isVisible()) {
        const html = `Some or all documents failed to upload.<br /><br /><b>${showAlert?.message1} #: ${showAlert?.message2}</b><br />Please submit a Freshdesk ticket with your Confirmation #  and all documents related to this request for assistance.<br /><br />Tip: Do not resubmit authorization request, unless advised.<span id="swal-loader-msg">`;
        const configUpdate = {
          ...baseConfig(setShowAlert, resetExistingApiResponse, reset),
          html:`${showAlert?.message1}`,
          title:"Error",
          icon: "warning",
          type: "error"
        } as import("sweetalert2").SweetAlertOptions;
        Swal.fire({
          ...configUpdate,
          html:
            (html ?? "") +
            getNoDocumentUploadedStatus(),
        });
      }
    }
};

export const callDecisionEngineSuccessSwal = (
  documentList: any,
  showAlert: any,
  setShowAlert: any,
  resetExistingApiResponse: any,
  reset: any,
  onDocumentClick: (id: number) => void,
  onClose?: (value: number) => void
) => {
  if (Swal.isVisible()) {
    if (Swal.isVisible()) {
      const html = `<div style="color: ${colors.fonts[4]};">Your authorization request has been approved.<br />
      <br />
      <b>Authorization Number - ${showAlert?.message2}</b>
      <br />
      <br />
      <div style="display: inline-block; font-weight: 600;">${showAlert?.message3 ?? ""}</div>
      <br />
      <br />
      </div>`;
      const configUpdate = {
        ...baseConfig(
          setShowAlert,
          resetExistingApiResponse,
          reset,
          onClose,
          colors.fonts[4]
        ),
        html: `${showAlert?.message1}`,
        confirmButtonText: "Close",
        showCloseButton: true,
        width: 'auto',
        title: "Success with Approval",
        icon: "success",
        type: "success"
      } as import("sweetalert2").SweetAlertOptions;
      Swal.fire({
        ...configUpdate,
        html:
          (html ?? "") +
          downloadDEDocument(documentList, onDocumentClick) +
          `<br /><br /><div style="color: ${colors.fonts[4]}; font-weight: 600;">${showAlert?.message4 ?? ""}</div>`,
      });
    }
  }
};